import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { CategoryType } from '@src/Application/Types/ComponentTypes'

import { Category, CategoryListWrapper, CategoryTitle, ImageWrapper } from './CategoryList.styled'

type Props = {
    categories: CategoryType[]
    label: string
}

export const CategoryList = ({ categories, label }: Props): JSX.Element => {
    const { t } = useTranslation()

    return (
        <CategoryListWrapper>
            <CategoryTitle>{t(label)}</CategoryTitle>
            {categories.map((category, i) => (
                <Category to={category.categoryUrl} key={`category-item-${i}`}>
                    {category.image && (
                        <ImageWrapper>
                            <Image image={category.image} imageAnimation={category.imageAnimation} />
                        </ImageWrapper>
                    )}
                    {category.title}
                </Category>
            ))}
        </CategoryListWrapper>
    )
}
